<template>
  <div class="onboarding-generic-service-form">
    <LsInput
      v-model="itemDetails"
      track-id="onboarding_generic_service_form-item_details"
      test-id="item_details"
      label="Which items on the property do you need serviced?"
      name="item_details"
      type="textarea"
      :validation="{ required: true }"
    />
    <LsInput
      v-model="desiredWorkDetails"
      track-id="onboarding_generic_service_form-desired_work_details"
      test-id="desired_work_details"
      label="What would you like done?"
      name="desired_work_details"
      type="textarea"
      :validation="{ required: true }"
    />
    <LsCheckboxes
      v-model="locations"
      :options="OrderServicesConstants.locations"
      label="Where on the property? (From the street)"
      track-id="onboarding_generic_service_form-locations"
      name="locations"
      test-id="locations"
      :validation="{ required: true }"
    />
    <LsInputMasked
      v-model="budget"
      track-id="onboarding_generic_service_form-budget"
      test-id="budget"
      label="What is your budget for this work?"
      name="budget"
      mask="currency"
    />
    <LsUploadPhotos
      v-model="images"
      track-id="onboarding_generic_service_form-images"
      test-id="images"
      label="Upload photos"
      name="images"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import { LsCheckboxes, LsInput, LsInputMasked, LsUploadPhotos } from '@/components/common';
import { OrderServicesConstants } from 'ls-constants';
import { mapActions, mapGetters } from 'vuex';
import { ONBOARDING__UPDATE_QUOTE, ONBOARDING__SELECTED_SERVICE } from '@/store/types';
import { lsRouterHelpers, lsValidationService } from 'ls-vue-common';
import { lsUploadPhotosHelper } from '@/helpers';

export default {
  name: 'OnboardingGenericServiceForm',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsCheckboxes,
    LsInput,
    LsInputMasked,
    LsUploadPhotos,
  },
  data() {
    return {
      service_id: lsRouterHelpers.getParam(this.$route, 'service_id'),

      // form
      itemDetails: '',
      desiredWorkDetails: '',
      locations: [],
      budget: '',
      images: [],
    };
  },
  computed: {
    ...mapGetters([ONBOARDING__SELECTED_SERVICE]),
    OrderServicesConstants() {
      return _.cloneDeep(OrderServicesConstants);
    },
    selectedService() {
      return this[ONBOARDING__SELECTED_SERVICE](this.service_id);
    },
  },
  created() {
    const { description, budget } = this.selectedService;
    if (_.isString(description)) {
      const formData = _.split(
        description,
        /Items needing service:\n|\n\nLocation \(from the street\):\n|\n\nDesired work to be completed:\n/
      );
      this.itemDetails = formData[2];
      this.desiredWorkDetails = formData[1];
    }

    const locations = _.map(OrderServicesConstants.locations, 'value');
    this.locations = _.filter(locations, (location) => {
      return this.selectedService[location];
    });

    this.budget = budget ? _.toString(budget) : '';
  },
  methods: {
    ...mapActions([ONBOARDING__UPDATE_QUOTE]),
    async updateQuote() {
      const isFormValid = await this.$validator.validateAll();
      const isUploadValid = lsUploadPhotosHelper.isValidUpload(this.images);

      if (!isFormValid || !isUploadValid) {
        return lsValidationService.scrollToInvalid();
      }

      this[ONBOARDING__UPDATE_QUOTE]({
        selectedService: this.selectedService,
        formData: {
          itemDetails: this.itemDetails,
          desiredWorkDetails: this.desiredWorkDetails,
          locations: this.locations,
          budget: this.budget,
        },
        images: this.images,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-generic-service-form > :not(:last-child) {
  margin-bottom: 50px;
}
</style>
